import { Link } from "react-router-dom";
import HotCommentRank from "./HotCommentRank";

const stats = [
  { value: "1,286", label: "累计围观事件" },
  { value: "42万+", label: "整理网友热评" },
  { value: "8,900", label: "收录高赞神回复" },
];

export default function Hero() {
  return (
    <section className="relative overflow-hidden border-b border-background-200 bg-background-100">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-primary-100 blur-3xl"
      ></div>
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -bottom-32 left-1/4 h-72 w-72 rounded-full bg-accent-100 blur-3xl"
      ></div>

      <div className="relative grid w-full grid-cols-1 gap-10 px-4 py-12 md:px-8 md:py-20 lg:grid-cols-12 lg:gap-12">
        <div className="animate-fade-up lg:col-span-7">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3.5 py-1.5 text-xs font-semibold text-primary-700">
            <span className="flex h-1.5 w-1.5 rounded-full bg-primary-500"></span>
            今日围观现场 · 实时更新
          </span>

          <h1 className="mt-5 font-heading text-3xl font-black leading-tight tracking-tight text-foreground-950 sm:text-4xl md:text-5xl lg:text-[3.4rem]">
            瓜田热评，把热门吃瓜的
            <span className="relative mx-1 inline-block text-primary-600">
              评论区
              <span className="absolute inset-x-0 -bottom-1 h-2 rounded-full bg-accent-300/70"></span>
            </span>
            搬到台前
          </h1>

          <p className="mt-6 max-w-2xl text-base leading-relaxed text-foreground-600 md:text-lg">
            这里不止有瓜，更有围观群众最精彩的那部分。我们聚合热门事件下的网友热评、犀利吐槽与高赞神回复，
            让你看事件、看评论、也看态度——感受吃瓜现场最热闹的氛围，发现最有意思的网友观点。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/events"
              className="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-fire-line mr-2 text-lg"></i>
              进入瓜田广场
            </Link>
            <Link
              to="/comments"
              className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-foreground-300 bg-background-50 px-6 py-3.5 text-sm font-semibold text-foreground-900 transition-colors hover:border-foreground-400 hover:bg-background-100"
            >
              <i className="ri-trophy-line mr-2 text-lg text-accent-600"></i>
              看高赞神回复
            </Link>
          </div>

          <dl className="mt-10 flex flex-wrap gap-x-10 gap-y-5">
            {stats.map((s) => (
              <div key={s.label}>
                <dt className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
                  {s.value}
                </dt>
                <dd className="mt-1 text-xs tracking-wide text-foreground-500 md:text-sm">{s.label}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="animate-fade-up lg:col-span-5">
          <HotCommentRank />
        </div>
      </div>
    </section>
  );
}